import React, { Component } from 'react';
import { connect } from 'react-redux';
import DesktopView from './DesktopView/DesktopView';
import MobileView from './MobileView/MobileView';
import MouseCatcher from './MouseCatcher/MouseCatcher';
import { EDITOR_STAGE_ID, MOUSE_SELECTION_ID, EDITOR_TEMPLATE_WRAPPER_ID } from 'crazyEditor/core/constants/editorConstants';
import shallowEqual from 'fbjs/lib/shallowEqual';
import QuickPreviewArrows from './QuickPreviewArrows/QuickPreviewArrows';
import connectWithRouter from 'shared/components/redux/connectWithRouter';
const EDITOR_TEMPLATE_VERSION = 3;

const classes = require('./EditorStage.scss');

const styles = {
  container: {
    width: '100%',
    height: '100%',
  },
};

@connectWithRouter(
  (state) => ({
    isDesktopView: state.editor.isDesktopView,
    isMobileView: state.editor.isMobileView,
    isPreviewMode: state.editor.isPreviewMode,
    isQuickPreviewMode: state.editor.isQuickPreviewMode,
    templateId: state.routing.location.query.id,
  })
)
export default class EditorStage extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
  }

  componentWillUpdate() {
    this.animation = false;
  }

  animation = true;

  render() {
    const {
      isMobileView,
      isDesktopView,
      isPreviewMode,
      isQuickPreviewMode,
      templateId,
      } = this.props;
    return (
      <div className={this.animation ? classes.fadeIn : null} id={EDITOR_STAGE_ID} style={styles.container}>
        <div id={MOUSE_SELECTION_ID}></div>
        { !isPreviewMode &&
        <MouseCatcher isMobileView={isMobileView} isDesktopView={isDesktopView}/>
        }
        <div className={classes.noSelect} id={EDITOR_TEMPLATE_WRAPPER_ID} data-template-version={EDITOR_TEMPLATE_VERSION} key={isQuickPreviewMode && templateId}>
          <DesktopView isVisible={isDesktopView} isPreviewMode={isPreviewMode} />
          <MobileView isVisible={isMobileView} isPreviewMode={isPreviewMode} />
        </div>
        <QuickPreviewArrows/>
      </div>
    );
  }
}
